/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CaseListLoadDto
 */
export interface CaseListLoadDto {
    /**
     * 
     * @type {string}
     * @memberof CaseListLoadDto
     */
    readTenantId?: string;
    /**
     * 
     * @type {string}
     * @memberof CaseListLoadDto
     */
    ingestTenantId?: string;
    /**
     * 
     * @type {number}
     * @memberof CaseListLoadDto
     */
    seededCaseRows?: number;
    /**
     * 
     * @type {number}
     * @memberof CaseListLoadDto
     */
    sampleIterations?: number;
    /**
     * 
     * @type {number}
     * @memberof CaseListLoadDto
     */
    pageSize?: number;
    /**
     * 
     * @type {number}
     * @memberof CaseListLoadDto
     */
    p95Ms?: number;
    /**
     * 
     * @type {number}
     * @memberof CaseListLoadDto
     */
    maxMs?: number;
    /**
     * 
     * @type {number}
     * @memberof CaseListLoadDto
     */
    elapsedMs?: number;
    /**
     * 
     * @type {boolean}
     * @memberof CaseListLoadDto
     */
    ingestOnOtherShard?: boolean;
}

/**
 * Check if a given object implements the CaseListLoadDto interface.
 */
export function instanceOfCaseListLoadDto(value: object): value is CaseListLoadDto {
    return true;
}

export function CaseListLoadDtoFromJSON(json: any): CaseListLoadDto {
    return CaseListLoadDtoFromJSONTyped(json, false);
}

export function CaseListLoadDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CaseListLoadDto {
    if (json == null) {
        return json;
    }
    return {
        
        'readTenantId': json['readTenantId'] == null ? undefined : json['readTenantId'],
        'ingestTenantId': json['ingestTenantId'] == null ? undefined : json['ingestTenantId'],
        'seededCaseRows': json['seededCaseRows'] == null ? undefined : json['seededCaseRows'],
        'sampleIterations': json['sampleIterations'] == null ? undefined : json['sampleIterations'],
        'pageSize': json['pageSize'] == null ? undefined : json['pageSize'],
        'p95Ms': json['p95Ms'] == null ? undefined : json['p95Ms'],
        'maxMs': json['maxMs'] == null ? undefined : json['maxMs'],
        'elapsedMs': json['elapsedMs'] == null ? undefined : json['elapsedMs'],
        'ingestOnOtherShard': json['ingestOnOtherShard'] == null ? undefined : json['ingestOnOtherShard'],
    };
}

export function CaseListLoadDtoToJSON(json: any): CaseListLoadDto {
    return CaseListLoadDtoToJSONTyped(json, false);
}

export function CaseListLoadDtoToJSONTyped(value?: CaseListLoadDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'readTenantId': value['readTenantId'],
        'ingestTenantId': value['ingestTenantId'],
        'seededCaseRows': value['seededCaseRows'],
        'sampleIterations': value['sampleIterations'],
        'pageSize': value['pageSize'],
        'p95Ms': value['p95Ms'],
        'maxMs': value['maxMs'],
        'elapsedMs': value['elapsedMs'],
        'ingestOnOtherShard': value['ingestOnOtherShard'],
    };
}

